<template>
    <div>
        <help></help>

        <support v-if="canSeeSupport"></support>
    </div>  

</template>

<script>
import support from './Support.vue';
import help from './widgets/Help.vue';
export default {
    components: {
        help, support
    },
    computed: {
        canSeeSupport() {
            return localStorage.roles.includes('Student') 
            || localStorage.roles.includes('Mentor')
            || localStorage.roles.includes('CampusMentor')
            || localStorage.roles.includes('Supervisor')
            && localStorage.transitioned != 'true'
        }
    }
}
</script>


// WEBPACK FOOTER //
// Help.vue?47d8e016